/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useMemo } from 'react';
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../assets/libs/csg-lib';
import { MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../CustomMaterial';

const OutsideWallModel = () => {
    const { gl } = useThree();

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false
    
     

    const leftWallModel = useMemo(() => {
        let model = new THREE.Shape();
        model.moveTo(-(params.p_d / 2 + 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) - 0.001 : params.p_h - 0.001);
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) - 0.001 : params.p_h - 0.001);
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, 0);
        model.lineTo(-(params.p_d / 2 + 0.15), 0);
        model.closePath();

        return model;
    }, [params.p_d, params.singleSlope, params.freeStandingSide, parseInt(params.p_u_t), params.p_w, params.p_h, params.p_r_p])
    
    const mainWallModel = useMemo(() => {

        let verticalHorizontalPos = {"x": params.p_w / -2 - 0.005,"y" : ((params.p_w_c_n && (params.p_l_w === 'Close' || params.p_u_c)) ? 2.935 : 0), "z" : params.p_d / -2 - 0.15}
        let verticalHorizontalRot = {"x":0,"y" : 0,"z" : Math.PI / 2}
        let patternLength = params.p_h - 0.01 + ((params.p_w_c_n && (params.p_l_w === 'Close' || params.p_u_c)) ? -2.935 : 0)
        let patternDepth = params.p_d + 0.3
        
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength, isPattern), extrudeSettings(patternDepth)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('left', 'wall'), extrudeSettings(1)))
        const meshWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(leftWallModel, extrudeSettings(1)))
    
        let meshWallModel_Temp = meshWallModel.clone();
        meshWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshWallModel_Temp.updateMatrixWorld();
    
        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(-params.p_w / 2 + 0.5, 0, -params.endStoragePositionZ);
        meshDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshDelModel_Temp.updateMatrixWorld();
    
        let meshWallDelModel_Temp = meshWallDelModel.clone();
        meshWallDelModel_Temp.position.set(-params.p_w / 2 + 0.5, 0, 0);
        meshWallDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshWallDelModel_Temp.updateMatrixWorld();
    
        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshWallDelModel_CSG = CSG.fromMesh(meshWallDelModel_Temp);
    
    
        const wallModel_CSG = meshWallModel_CSG.subtract(meshDelModel_CSG);
        const meshWallDel_CSG = wallModel_CSG.intersect(meshWallDelModel_CSG);
        const CSGWallModel = CSG.toMesh(
            meshWallDel_CSG,
            new THREE.Matrix4()
        )
    
        /************** cutting hole in wainscot using CSG ***************/
        let wainscotVerticalHorizontalPos = {"x": params.p_w / -2 - 0.005,"y" : 0, "z" : params.p_d / -2 - 0.15}
        let wainscotVerticalHorizontalRot = {"x":0,"y" : 0,"z" : Math.PI / 2}
        let lengthPattern = 3
        let depthPattern = params.p_d + 0.3
        
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern, isPattern), extrudeSettings(depthPattern)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(wainscotVerticalHorizontalPos.x,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);
        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDelModel_CSG);
        const wainscotModelCSG = wainscotModel_CSG.intersect(meshWallDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(
            wainscotModelCSG,
            new THREE.Matrix4()
        )

        /****************************************** *********/

        return {
            wall: CSGWallModel.geometry,
            wainscot: CSGWainscotModel.geometry
        };
    
    }, [params.wallTexture, params.endStoragePositionZ, params.p_d, params.p_h, params.p_w, params.p_u_c, parseInt(params.p_u_t), params.p_r_p,params.singleSlope && params.freeStandingSide === "left", params.p_w_c_n, params.p_l_w, params.p_v_w,const_var.newDoorsArray])

    return (
        <>
            <mesh name="c_b_l_s_w" geometry={mainWallModel.wall} >
                <MaterialOuterWallNew isPattern={isPattern}  visibleSection={"center"} />
            </mesh>

            {params.p_w_c_n === true && mainWallModel.wainscot &&
                <mesh name="c_b_l_s_w_wainscot" geometry={mainWallModel.wainscot} position={[-0.005,0,0]}>
                    <MaterialWainScotWallNew isPattern={isPattern}  visibleSection={"center"} />
                </mesh>
            } 
        </>
    )
}

export default OutsideWallModel